const COLLECTIONS = [
  { title: '2026暑期档大片合集', desc: '今夏最火爆的动作大片、科幻巨制一网打尽', count: '42部', icon: 'ri-sun-line', accent: true },
  { title: '高分动作片精选', desc: 'IMDB 8.0+ 高分动作电影，部部经典', count: '68部', icon: 'ri-knife-line', accent: false },
  { title: '爆笑喜剧片合集', desc: '笑到停不下来，解压放松首选', count: '55部', icon: 'ri-emotion-happy-line', accent: false },
  { title: '国产新片速递', desc: '最新国产电影抢先看，持续更新中', count: '31部', icon: 'ri-flag-2-line', accent: false },
  { title: '经典港片回味', desc: '那些年我们追过的经典香港电影', count: '89部', icon: 'ri-building-2-line', accent: true },
  { title: '科幻巨制系列', desc: '从星际穿越到时间旅行，脑洞大开', count: '47部', icon: 'ri-rocket-line', accent: false },
  { title: '悬疑烧脑片单', desc: '挑战智商，每部都让人猜不到结局', count: '36部', icon: 'ri-search-eye-line', accent: false },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            电影专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">精心策划的影片合集，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {COLLECTIONS.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 border border-background-200/60 rounded-lg p-5 hover:border-primary-500/40 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div
                  className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                    item.accent
                      ? 'bg-accent-500/15 text-accent-500'
                      : 'bg-primary-500/15 text-primary-500'
                  }`}
                >
                  <i className={`${item.icon} text-lg`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{item.desc}</p>
                  <div className="flex items-center gap-1 mt-3">
                    <span className={`text-xs font-medium ${item.accent ? 'text-accent-500' : 'text-primary-500'}`}>
                      {item.count}
                    </span>
                    <span className="text-xs text-foreground-400">影片</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}